export default __webpack_public_path__ + "static/media/android-mockup.2aef0575.webp";